var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgDp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "igDP1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(-306 -278)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 74,
    height: 75,
    rx: 6,
    transform: "translate(306 278)",
    fill: "#575984"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Ingress",
    transform: "translate(316.624 307.5)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ingress")), /*#__PURE__*/React.createElement("text", {
    id: "DP_1",
    "data-name": "DP 1",
    transform: "translate(321 332.5)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DP 1")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgDp1);
export default __webpack_public_path__ + "static/media/igDP1.2f7a36eb217dbe307b840bd055753384.svg";
export { ForwardRef as ReactComponent };